import { Col, Container, Row } from "react-bootstrap";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";
import classes from "./styles.module.scss";
import clsx from "classnames";
import Image from "@/ui/Image";
import { getGlobal } from "@/functions/getGlobal";
import { cleanMarkup } from "@/functions/cleanMarkup";

export const PopularRolesPageGridSection = ({ className, page, section_1_text, section_2_text, section_3_text }) => {
  const pathPrefix = `page.popular.roles.${page.url_slug}.grid`;
  // const locale = useLocale();

  // const global = getGlobal();

  // const isSection1HaveText = global[`${pathPrefix}.section-1.text.${locale}`]?.length > 0;
  // const isSection2HaveText = global[`${pathPrefix}.section-2.text.${locale}`]?.length > 0;
  // const isSection3HaveText = global[`${pathPrefix}.section-3.text.${locale}`]?.length > 0;

  return (
    <div className={clsx(className, classes.content)}>
      <Container>
        {section_1_text && (
          <Row className="py-md-5 mb-md-5">
            <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
              <Image
                img={{ path: `${pathPrefix}.section-1.image`, src: "/assets/specialism/1.jpg" }}
                size="650x"
                alt=""
              />
            </Col>
            <Col xs={12} md={6} className="p-5 bg-primary text-white text-overlay">
              {/* {isSection1HaveText ? (
                <DynamicHtml path={`${pathPrefix}.section-1.text.${locale}`} className="text-overlay__content mb-4" />
              ) : ( */}
              <div
                className="text-overlay__content mb-4"
                dangerouslySetInnerHTML={{ __html: cleanMarkup(section_1_text) }}
              />
              {/* )} */}

              <Image
                className="text-overlay__background"
                img={{ path: `${pathPrefix}.section-1.bg`, src: "/assets/grid/transparent.png" }}
                size="650x"
                alt=""
              />
            </Col>
          </Row>
        )}

        {section_2_text && (
          <Row className="flex-column flex-md-row-reverse">
            <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
              <Image
                img={{ path: `${pathPrefix}.section-2.image`, src: "/assets/specialism/1.jpg" }}
                size="650x"
                alt=""
              />
            </Col>
            <Col xs={12} md={6} className="p-5 bg-light text-overlay">
              {/* {isSection2HaveText ? (
                <DynamicHtml className="text-overlay__content" path={`${pathPrefix}.section-2.text.${locale}`} />
              ) : ( */}
              <div
                className="text-overlay__content mb-4"
                dangerouslySetInnerHTML={{ __html: cleanMarkup(section_2_text) }}
              />
              {/* )} */}

              <Image
                className="text-overlay__background"
                img={{ path: `${pathPrefix}.section-2.bg`, src: "/assets/grid/bg.png" }}
                size="650x"
                alt=""
              />
            </Col>
          </Row>
        )}
        {section_3_text && (
          <Row className="py-md-5 my-md-5">
            <Col xs={12} md={6} className={clsx(classes.content__image, "p-5")}>
              <Image
                img={{ path: `${pathPrefix}.section-3.image`, src: "/assets/specialism/1.jpg" }}
                size="650x"
                alt=""
              />
            </Col>
            <Col xs={12} md={6} className="p-5 bg-secondary text-white text-overlay">
              {/* {isSection3HaveText ? (
                <DynamicHtml
                  path={`${pathPrefix}.section-3.text.${locale}`}
                  className="text-overlay__content mb-md-5"
                />
              ) : ( */}
              <div
                className="text-overlay__content mb-4"
                dangerouslySetInnerHTML={{ __html: cleanMarkup(section_3_text) }}
              />
              {/* )} */}

              <Image
                className="text-overlay__background"
                img={{ path: `${pathPrefix}.section-3.bg`, src: "/assets/grid/transparent.png" }}
                size="650x"
                alt=""
              />
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

PopularRolesPageGridSection.defaultProps = {
  className: "pb-md-5 mb-md-5",
};
